<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MDmHt1/tc-custom/9781488091766.jpg?1724535328966" alt="This image is the cover for the book Claiming His Secret Heir, The McNeill Magnates"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Claiming His Secret Heir, The McNeill Magnates
      </h1>
      <p class="bookDescription body article font2">
        <b><i>USA Today</i>–Bestselling Author: He won his wife’s heart once . . . Can he do it again?</b><br/><br/>When Caroline McNeill shows up outside her husband’s mansion, she claims to have no memory of the past year . . . or their passion-filled honeymoon. But faking amnesia is the only way Caroline can find out if Damon was behind her abduction. She needs to trust him—a man she craves but still barely knows—before she can tell him about their infant son. Did the Silicon Valley mogul merely marry to claim an inheritance and then dispose of her? Or is what they share real and forever?<br/><br/><b>Praise for the series</b><br/><br/>“Each book has a definitive romance that burns hot and bright, while the continuing story arc of finding a wife and meeting the inheritance deadline ties each book together, and keeps readers wanting more.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanne Rock
      </h2>
      
      <p class="authorDescription body article"><I>USA&#160;TODAY</I> bestselling author Joanne Rock credits her decision to write romance&#160;to a book she picked up during a flight delay that engrossed her so thoroughly, she didn&#39;t mind at all when her flight was delayed two more times. Giving her readers the chance to escape into another world has motivated her to write over one hundred books for a variety of Harlequin series.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?93e36f4e